import { Box, Button, Modal, Typography } from "@mui/material";
import "./SuccessCaseImageModal.scss";

export default function SuccessCaseImageModal(props: {
	openSuccessModal: boolean;
	setOpenSuccessModal: (open: boolean) => void;
	title: string;
	subtitle: string;
	content: any;
	nextButton: string;
	disableButton?: boolean;
	cancel: () => void;
	save: () => void;
}) {
	return (
		<Modal
			open={props.openSuccessModal}
			onClose={() => props.setOpenSuccessModal(false)}
		>
			<Box className="sc-image-modal">
				<Box className="sc-image-modal__header">
					<Box className="sc-image-modal__header__texts">
						<Typography className="sc-image-modal__header__texts-title">
							{props.title}
						</Typography>
						<Typography className="sc-image-modal__header__texts-subtitle">
							{props.subtitle}
						</Typography>
					</Box>
				</Box>
				<Box className="sc-image-modal__content">
					{props.content}
					<Box className="sc-image-modal__buttons">
						<Button
							className="sc-image-modal__buttons-cancel"
							onClick={props.cancel}
							disableRipple
						>
							<Typography>Cancelar</Typography>
						</Button>
						<Button
							className="sc-image-modal__buttons-save"
							disabled={props.disableButton}
							onClick={props.save}
							disableRipple
						>
							<Typography>{props.nextButton}</Typography>
						</Button>
					</Box>
				</Box>
			</Box>
		</Modal>
	);
}
